import { css } from 'linaria'

export default css`
  justify-content: center;
  align-items: center;

  ._input {
    background: transparent;
    color: inherit;
    outline: none;
  }
`
